import React from "react";
import Input from "../../../../../../../components/Input";
import useImmolizedStore from "../../store/useStore";

export default function Row1And2() {
  const { defaultValues } = useImmolizedStore();
  const { saveDataOfField } = useImmolizedStore();
  return (
    <>
      <div className="box-row">
        <Input
          name="name"
          label="Nome do Produto"
          placeholder="Digite o nome do produto"
          value={defaultValues?.name}
          setValue={(event) => saveDataOfField(event.target)}
          required={true}
        />
        <Input
          name="asset_number"
          label="Número do Patrimônio"
          placeholder="Digite o número do Patrimônio"
          value={defaultValues?.asset_number}
          setValue={(event) => saveDataOfField(event.target)}
          required={true}
        />
      </div>
      <div className="box-row">
        <Input
          name="description"
          label="Descrição"
          placeholder="Digite a Descrição"
          value={defaultValues?.description}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="purchase_amount"
          label="Valor do Item"
          placeholder="Digite o valor"
          value={defaultValues?.purchase_amount}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
    </>
  );
}
